import React, { useState, useEffect, useRef } from "react"
import { Link, useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import userAvatar from "../assets/img/img1.jpg";
import { Spinner, Badge } from "react-bootstrap";

export default function Header({ onSkin }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const ROLES = {
    SUPER_ADMIN: 'Super Administrateur',
    ADMIN: 'Administrateur',
    PASTEUR: 'Pasteur',
    ANCIEN: 'Ancien',
    DIACRE: 'Diacre',
    DP: 'DP',
    ACCUEIL: 'Accueil',
    EVANGELISTE: 'Evangéliste',
    CHANTRE: 'Chantre',
    CHORISTE: 'Choriste',
    INTERCESSEUR: 'Intercesseur(se)',
    SECURITE: 'Membre de la sécurité',
    NOUVEAU: 'Nouveau'
  };

  // Référence pour l'intervalle
  const intervalRef = useRef(null);

  // ✅ Fonctions utilisateur (définies en dehors du JSX)
  const getUserInitials = () => {
    if (!user) return 'U';
    
    const prenom = user.prenom || user.prenom_utilisateur || '';
    const nom = user.nom || user.nom_utilisateur || '';
    
    const initialPrenom = prenom ? prenom.charAt(0).toUpperCase() : '';
    const initialNom = nom ? nom.charAt(0).toUpperCase() : '';
    
    return initialPrenom + initialNom || 'U';
  };

  const getUserFullName = () => {
    if (!user) return 'Utilisateur';
    
    const prenom = user.prenom || user.prenom_utilisateur || '';
    const nom = user.nom || user.nom_utilisateur || '';
    
    return (prenom + ' ' + nom).trim() || 'Utilisateur';
  };

  const getUserRole = () => {
    if (!user || !user.role) return 'Non connecté';
    
    const roles = {
      'admin': 'Administrateur',
      'gestionnaire': 'Gestionnaire',
      'commercial': 'Commercial',
      'magasinier': 'Magasinier'
    };
    
    return roles[user.role] || user.role;
  };

  // ✅ Vérification de l'utilisateur
  useEffect(() => {
    const checkUser = () => {
      try {
        const userStr = localStorage.getItem("user");
        console.log("Header - userStr brut:", userStr);
        
        if (userStr && userStr !== "undefined" && userStr !== "null") {
          const userData = JSON.parse(userStr);
          
          if (userData && (userData.id_utilisateur || userData.id)) {
            setUser(userData);
            setIsLoggedIn(true);
            console.log("✅ Header - Utilisateur connecté:", userData);
          } else {
            console.log("Header - Utilisateur invalide (pas d'ID)");
            localStorage.removeItem("user");
            setUser(null);
            setIsLoggedIn(false);
          }
        } else {
          console.log("Header - Aucun utilisateur trouvé");
          setUser(null);
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("❌ Header - Erreur de parsing:", error);
        localStorage.removeItem("user");
        setUser(null);
        setIsLoggedIn(false);
      }
    };

    checkUser();
    
    const handleStorageChange = (e) => {
      if (e.key === "user") {
        checkUser();
      }
    };
    
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // ✅ Récupérer les notifications depuis l'API
  const fetchNotifications = async (isAutoRefresh = false) => {
    try {
      if (isAutoRefresh) {
        setIsRefreshing(true);
      } else {
        setLoadingNotifications(true);
      }
      
      const response = await fetch(
        'https://sawd.julesferry-ga.com/api/notifications.php?action=all&limit=10'
      );
      
      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          const previousCount = unreadCount;
          setNotifications(result.data);
          setUnreadCount(result.unread || 0);
          
          if (result.unread > previousCount && previousCount > 0) {
            console.log("🔔 Nouvelles notifications!");
          }
        }
      }
    } catch (error) {
      console.error("Erreur chargement notifications:", error);
    } finally {
      if (isAutoRefresh) {
        setIsRefreshing(false);
      } else {
        setLoadingNotifications(false);
      }
    }
  };

  // ✅ Charger les notifications
  useEffect(() => {
    if (isLoggedIn && user) {
      fetchNotifications(false);
      
      intervalRef.current = setInterval(() => {
        fetchNotifications(true);
      }, 30000);
      
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [isLoggedIn, user]);

  // ✅ Marquer une notification comme lue
  // const markAsRead = async (notificationId) => {
  //   try {
  //     const userId = user?.id_utilisateur || user?.id;
      
  //     const response = await fetch(
  //       `https://sawd.julesferry-ga.com/api/notifications.php?user_id=${userId}`,
  //       {
  //         method: 'PUT',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ notification_id: notificationId, read: true })
  //       }
  //     );
      
  //     if (response.ok) {
  //       setNotifications(prev => 
  //         prev.map(n => 
  //           n.id === notificationId ? { ...n, read: true } : n
  //         )
  //       );
  //       setUnreadCount(prev => Math.max(0, prev - 1));
  //     }
  //   } catch (error) {
  //     console.error("Erreur marquage notification:", error);
  //   }
  // };

  // ✅ Marquer toutes comme lues
  // const markAllAsRead = async () => {
  //   try {
  //     const userId = user?.id_utilisateur || user?.id;
      
  //     const response = await fetch(
  //       `https://sawd.julesferry-ga.com/api/notifications.php?user_id=${userId}`,
  //       {
  //         method: 'PUT',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ read_all: true })
  //       }
  //     );
      
  //     if (response.ok) {
  //       setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  //       setUnreadCount(0);
  //     }
  //   } catch (error) {
  //     console.error("Erreur marquage toutes notifications:", error);
  //   }
  // };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  }

  const handleLogout = (e) => {
    if (e) e.preventDefault();
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    console.log("Header - Déconnexion");
    navigate("/pages/signin2");
  };

  // ✅ Fonctions de thème
  const skinMode = (e) => {
    e.preventDefault();
    
    const parent = e.target.parentNode;
    if (parent) {
      const nodes = parent.children;
      for (let node of nodes) {
        node.classList.remove("active");
      }
    }
    
    e.target.classList.add("active");
    
    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem('skin-mode', skin);
      if (onSkin) onSkin(skin);
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem('skin-mode');
      if (onSkin) onSkin('');
    }
  };

  const sidebarSkin = (e) => {
    e.preventDefault();
    
    const parent = e.target.parentNode;
    if (parent) {
      const nodes = parent.children;
      for (let node of nodes) {
        node.classList.remove("active");
      }
    }
    
    e.target.classList.add("active");

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin");
    }
  };

  // ✅ Obtenir l'icône selon le type de notification
  const getNotificationIcon = (type) => {
    const icons = {
      'stock_critique': 'ri-alert-line text-danger',
      'rupture_stock': 'ri-close-circle-line text-danger',
      'inventaire': 'ri-file-list-3-line text-info',
      'commande': 'ri-shopping-cart-line text-warning',
      'facture': 'ri-file-list-line text-success',
      'devis': 'ri-file-copy-line text-primary',
      'paiement': 'ri-bank-card-line text-success',
      'utilisateur': 'ri-user-line text-secondary'
    };
    return icons[type] || 'ri-notification-line text-primary';
  };

  // ✅ Formater la date relative
  const getRelativeTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);
    
    if (diffSec < 60) return "À l'instant";
    if (diffMin < 60) return `Il y a ${diffMin} min`;
    if (diffHour < 24) return `Il y a ${diffHour}h`;
    if (diffDay < 7) return `Il y a ${diffDay}j`;
    return date.toLocaleDateString();
  };

  // ✅ Composant NotificationList
  const NotificationList = () => {
    if (loadingNotifications && !isRefreshing) {
      return (
        <li className="list-group-item text-center py-4">
          <Spinner animation="border" size="sm" variant="primary" />
          <p className="mt-2 small">Chargement...</p>
        </li>
      );
    }

    if (!notifications || notifications.length === 0) {
      return (
        <li className="list-group-item text-center py-4">
          <i className="ri-notification-off-line fs-1 text-muted mb-2"></i>
          <p className="text-muted small">Aucune notification</p>
        </li>
      );
    }

    // return notifications.slice(0, 5).map((item, index) => (
    //   <li 
    //     className={`list-group-item ${!item.read ? 'bg-light' : ''}`} 
    //     key={index}
    //     onClick={() => !item.read && markAsRead(item.id)}
    //     style={{ cursor: !item.read ? 'pointer' : 'default' }}
    //   >
    //     <div className="d-flex gap-3">
    //       <div className={`avatar ${item.read ? '' : 'online'}`}>
    //         <i className={getNotificationIcon(item.type)} style={{ fontSize: '20px' }}></i>
    //       </div>
    //       <div className="list-group-body flex-grow-1">
    //         <p className="mb-1 fw-semibold small">{item.title}</p>
    //         <p className="small text-muted mb-1">{item.message}</p>
    //         <div className="d-flex justify-content-between align-items-center">
    //           <span className="small text-muted">
    //             <i className="ri-time-line me-1"></i>
    //             {getRelativeTime(item.created_at)}
    //           </span>
    //           {!item.read && (
    //             <Badge bg="primary" pill className="px-2 text-white" style={{ fontSize: '0.7rem' }}>
    //               Nouveau
    //             </Badge>
    //           )}
    //         </div>
    //       </div>
    //     </div>
    //   </li>
    // ));
  };

  return (
    <div className="header-main px-3 px-lg-4">
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill"></i>
      </Link>

      <div className="form-search me-auto">
        <input type="text" className="form-control" placeholder="Rechercher..." />
        <i className="ri-search-line"></i>
      </div>

      <Dropdown className="dropdown-skin" align="end">
        {/* Votre contenu dropdown-skin ici */}
      </Dropdown>

      {/* Notifications dynamiques */}
      {/* <Dropdown className="dropdown-notifications ms-2" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="position-relative">
            <i className="ri-notification-3-line fs-5"></i>
            {unreadCount > 0 && (
              <Badge 
                bg="danger" 
                pill 
                className="position-absolute top-0 start-100 translate-middle p-1"
                style={{ fontSize: '0.6rem' }}
              >
                {unreadCount > 9 ? '9+' : unreadCount}
              </Badge>
            )}
            {isRefreshing && (
              <Spinner 
                animation="border" 
                size="sm" 
                variant="primary" 
                className="position-absolute top-0 start-0"
                style={{ width: '12px', height: '12px' }}
              />
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f dropdown-menu-fit" style={{ width: '320px' }}>
          <div className="dropdown-menu-header d-flex align-items-center justify-content-between p-3 border-bottom">
            <h6 className="mb-0 fw-semibold">Notifications</h6>
            {unreadCount > 0 && (
              <Link to="#" onClick={markAllAsRead} className="small text-primary">
                Tout marquer comme lu
              </Link>
            )}
          </div>
          <ul className="list-group list-group-flush" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <NotificationList />
          </ul>
          <div className="dropdown-menu-footer text-center p-2 border-top">
            <Link to="/notifications" className="small text-primary">
              Voir toutes les notifications
            </Link>
          </div>
        </Dropdown.Menu>
      </Dropdown> */}

      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online">
            {isLoggedIn && user?.avatar ? (
              <img src={`https://josephsbusiness.com/assets/images/${user.avatar}`} alt="Avatar" />
            ) : (
              <div className="avatar-placeholder" style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: '#007bff',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 'bold',
                textTransform: 'uppercase'
              }}>
                {getUserInitials()}
              </div>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-body">
            <div className="avatar avatar-xl online mb-3">
              {isLoggedIn && user?.avatar ? (
                <img src={`https://josephsbusiness.com/assets/images/${user.avatar}`} alt="Avatar" />
              ) : (
                <div className="avatar-placeholder" style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '50%',
                  backgroundColor: '#007bff',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase'
                }}>
                  {getUserInitials()}
                </div>
              )}
            </div>
            <h5 className="mb-1 text-dark fw-semibold">{getUserFullName()}</h5>
            <p className="fs-sm text-secondary">{getUserRole()}</p>

            <nav className="nav">
              <Link to={`/fidele`}>
                <i className="ri-profile-line"></i> Voir profil
              </Link>
            
            </nav>
            <hr />
            <nav className="nav">
             
             
              <Link to="#" onClick={handleLogout}>
                <i className="ri-logout-box-r-line"></i> Déconnexion
              </Link>
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );

  // Fonction helper pour le profil
  function getProfileRoute() {
    if (!user || !user.role) return 'fidele';
    
    switch(user.role) {
      case ROLES.PASTEUR:
        return 'pasteur';
      case ROLES.DP:
      case ROLES.ANCIEN:
      case ROLES.DIACRE:
        return 'dp';
      default:
        return 'fidele';
    }
  }
}